module.exports = __tmimport("frontend");